import * as p from 'ayvri-std/lib/promise';
import { setMessage, clearMessage } from '../Actions';
// @NOTE: On staging the check for new tracks to process is 60 seconds, with about 20 seconds
//        worst-case processing time. There should be less than one second of check time.
const MAX_POLL_DURATION = 90000;
const POLL_FREQUENCY = 3000;
export function pollForActivity(activity, pollDuration, pollFrequency) {
    const pingActivity = () => {
        const path = `2.0/activities/${activity.accountId}/${activity.activityId}`;
        const uri = `${process.env.AYVRI_API}/${path}`;
        return fetch(uri, { headers: { accept: 'application/json' } })
            .then(res => {
            if (res.ok)
                return res.json();
            return Promise.reject(new Error(`Request failed with ${res.status} (${res.statusText})`));
        })
            .then(json => {
            if (!json.activity)
                return Promise.reject(new Error('Invalid response format'));
            return json.activity.pathUrl ? p.ready(json.activity) : p.pending();
        });
    };
    const kPollCount = pollDuration / pollFrequency;
    const pollComplete = p.poll(pingActivity, kPollCount, pollFrequency);
    return pollComplete.catch(e => ({ error: e, title: activity.title }));
}
export default function checkTracksProcessed(activities, store) {
    // Get the list of activities that are not yet processed
    const unprocessedTracks = activities.filter(a => !a.pathUrl);
    if (unprocessedTracks.length === 0) {
        return Promise.resolve(activities);
    }
    // Start the list of processed activities
    const processedTracks = activities.filter(a => a.pathUrl);
    // Let the user know that we're waiting on tracks to finish processing
    store.dispatch(setMessage('trackInProcess'));
    // Poll the server for the activities, waiting until they've all completed or error'd
    const timeout = MAX_POLL_DURATION;
    const frequency = POLL_FREQUENCY;
    const getTracks = unprocessedTracks.map(act => pollForActivity(act, timeout, frequency));
    return Promise.all(getTracks).then(processed => {
        // Now that we've processed all the tracks, clear the user visible message
        const findProcessing = store.getState().messages.find(m => m.caller === 'trackInProcess');
        store.dispatch(clearMessage(findProcessing.messageId));
        // Replace the scene's activities array with the new successfully downloaded activities
        processed.forEach(a => {
            if (a.error) {
                console.warn(`Failed to fetch Activity "${a.title}":`, a.error.message);
                store.dispatch(setMessage('errorProcessingTrack'));
            }
            else {
                processedTracks.push(a);
            }
        });
        return processedTracks;
    });
}
